// Streamer     channelId
//
// guanzo:      23435553
// guanzotest:  183894740
// EsfandTV:    38746172
// jaycgee:     58208096
// Accropolis:  117011503
// Swebliss:    50684398
// Buerinho:    189139646

import { LIST_TYPE_VOTES, SUGGESTION_MAX_LENGTH } from './constants'

export const MIN_MINUTES_BETWEEN_POSTS = 1
export const ROLE_VIEWER = 'viewer'
export const ROLE_MODERATOR = 'moderator'
export const ROLE_BROADCASTER = 'broadcaster'
export const DEFAULT_CHANNEL_NAME = 'streamer'

// READ ONLY USER. This user is not logged into twitch.
export const isAnonymousUser = user => user.opaqueId.charAt(0) === 'A'
// READ ONLY USER. Logged in but has NOT granted the extension their Twitch ID.
export const isOpaqueUser = user => {
    return !user.id && user.opaqueId.charAt(0) === 'U'
}

// Logged in and has granted the extension their Twitch ID.
// Can post, upvote, emote, etc.
export const isIdentityLinkedUser = user => !!user.id && !user.isUnlinked

// Can moderate suggestions if broadcaster allows
export const isModerator = user => user.role === ROLE_MODERATOR
export const isModeratorOfChannel = (user, channelId) => {
    // user.channelId is the channel that the user navigated to in the browser.
    return isModerator(user) && user.channelId === channelId
}

export const isBroadcaster = user => user.role === ROLE_BROADCASTER
export const isBroadcasterOfChannel = (user, channelId) => {
    return isBroadcaster(user) && user.id === channelId
}

// Channel owner or (moderator & owner allows mods as admin)
export const isSuggestionBoxAdmin = (user, channelToEdit) => {
    const { allowModAdmin, channelId } = channelToEdit
    const isChannelOwner = isBroadcasterOfChannel(user, channelId)
    const isChannelMod = isModeratorOfChannel(user, channelId)

    // cl('user', user)
    // cl('channelToEdit', channelToEdit)
    // cl('isChannelOwner', isChannelOwner)
    // cl('isChannelMod', isChannelMod)
    // cl('allowModAdmin', allowModAdmin)
    // cl('canUserEditChannelPost', isChannelOwner || (isChannelMod && allowModAdmin))

    return isChannelOwner || (isChannelMod && allowModAdmin)
}

export function jwtPayloadToUserObj (jwtPayload) {
    const d = jwtPayload
    return {
        id: d.user_id || null,
        opaqueId: d.opaque_user_id,
        channelId: d.channel_id,
        // is_unlinked is missing for channel owner
        isUnlinked: d.is_unlinked,
        pubsubPerms: d.pubsub_perms,
        role: d.role,
    }
}

// TODO: Some caller may pass in a moment object instead of a Date. Do not
// assume it is a Date.
export function isPostCooldownOver (lastSuggestionDate, postCooldownMinutes = MIN_MINUTES_BETWEEN_POSTS) {
    if (!lastSuggestionDate) {
        return true
    }

    if (lastSuggestionDate.toDate) {
        console.warn('Pass in a Date instead of a moment object plz.')
        lastSuggestionDate = lastSuggestionDate.toDate()
    }

    const diffSec = (Date.now() - lastSuggestionDate.getTime()) / 1000
    const diffMin = diffSec / 60

    return diffMin >= postCooldownMinutes
}

export const defaultChannelSettings = () => ({
    title: 'Suggestion Box',
    titleFontSize: 32, // px
    titleGradient: '',
    titleFontUrl: '',
    useTextHeader: true,
    headerImgUrl: '',
    // Defaults to roboto, which is always loaded. User fonts only affects
    // the sbox, not the config page.
    fontUrl: '',
    suggestionMaxLength: SUGGESTION_MAX_LENGTH,
    filterProfanity: true,
    requireApproval: false,
    allowModAdmin: true,
    postCooldownMinutes: MIN_MINUTES_BETWEEN_POSTS,
    listType: LIST_TYPE_VOTES,
    allowLinks: true,
    revealLinkPreview: false,
    messageToViewer: '',
    email: '',
    theme: {
        mode: 'user',
        color: '#F57C00',
        // TODO: colorSecondary is deprecated.
        // colorSecondary: '#E65100',
        colorContrast: '#F6F9FC', // Bad name, this is the text color.
    },
})

export const defaultChannelState = () => ({
    channelId: null,
    channelLogin: null,
    channelName: DEFAULT_CHANNEL_NAME,
    ...defaultChannelSettings(),
})
